<template>
  <div class="section">
    <div>
      <span class="title">{{ $t('SeaExport.CargoInfo') }}</span>
      <booking-manifest-goods-info
        :job="job"
        :is-editing="isEditing"
        :lcl-view="true"
        :is-or-not-display-so-no="true"
        :manifest-info="manifestInfo"
        @soNoChange="soNoChangeHandler"
      />
    </div>
    <div style="margin-top: 10px">
      <el-button
        :disabled="action!=='look'"
        type="primary"
        @click="cfmBtnClickHandler"
      >{{ $t('SeaExport.Confirm') }}</el-button>
    </div>
  </div>
</template>

<script>
import bookingManifestGoodsInfo from '../bookingManifestGoodsInfo'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { mergeArray } from '@/utils/commonUtil'
import { Job } from '@/class/model/booking/Job'
import { ManifestInfo } from '@/class/model/booking/ManifestInfo'
import { synchronizationGoodsInfo } from '@/api/seaExport/manifestInfo'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'

export default {
  name: 'TabPrePlanBookingLcl',
  components: { bookingManifestGoodsInfo },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      job: {},
      manifestInfo: {}
    }
  },
  computed: {
    isEditing() {
      return this.action === 'edit'
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.job = row
      if (row.uuid) {
        await new Job(row).getManifestInfo(true)
      }
      if (!row.manifestInfo) {
        row.manifestInfo = new ManifestInfo().fillDefaultValue().getData()
        row.manifestInfo.jobUuid = row.uuid
      }
      this.manifestInfo = row.manifestInfo
    },
    getSubmitData() {
      if (!this.manifestInfo) return {}
      return { manifestInfos: [this.manifestInfo] }
    },
    cfmBtnClickHandler() {
      const manifestGoods = this.manifestInfo.manifestGoods
      if (!manifestGoods || manifestGoods.length === 0) {
        throw new ErrorTip(this.$t('SeaExport.CargoInformationIsEmpty'))
      }
      this.$confirm(this.$t('SeaExport.RelevantTicketsResetAndUpdated'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        synchronizationGoodsInfo({ manifestInfoUuid: this.manifestInfo.uuid, jobKey: this.job.uuid }).then(res => {
          this.$emit('reload')
          this.$message.success(this.$t('SeaExport.ManifestConfirmed'))
        }).catch().finally()
      }).catch(() => { })
    },
    // 组装打印参数
    getPrintData() {
      if (this.manifestInfo && this.manifestInfo.uuid) {
        const params = {}
        // params.MANIFEST_INFO_UUID = this.manifestInfo.uuid
        PrintTemplateUtil.buildPrintDataByManifestInfo(this.manifestInfo, params)
        params.category = 'MANIFESTINFO'
        params.ctx = new ManifestInfo(this.manifestInfo)
        return params
      }
    },
    soNoChangeHandler(quantity) {
      let isFlag = false
      const charges = []
      for (const charge of this.job.charges) {
        // 更新箱数的费用
        if (SEUtils.checkAdjust(charge) && charge.measure === 'SONO') {
          charge.quantity = quantity
          // CARGO-4980 单价是否含税
          if (charge.unitPriceIncludeTax) {
            ChargeUtils.calculateTaxAmount(charge, charge.quantity * charge.unitRate, charge.taxRate)
          } else {
            ChargeUtils.calculateTax(charge, charge.quantity * charge.unitRate, charge.taxRate)
          }
          charges.push(charge)
          if (!isFlag) isFlag = true
        }
      }
      if (isFlag && charges.length > 0) {
        this.context.modifiedData.charges = this.context.modifiedData.charges || []
        mergeArray(this.context.modifiedData.charges, charges) // 只记住修改过的数据
      }
      this.context.reloadCharge = true
    }
  }
}
</script>

<style>
</style>
